import { makeAutoObservable, reaction } from 'mobx';

// Per-tab selection state for the Active Trade Plans view. Selection is
// application state keyed by immutable tradePlanId, independent of DOM focus.
export class TradePlanSelectionStore {
  root;
  selectedTradePlanId = null;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    // Clear selection when the selected trade plan disappears.
    // Never auto-select another trade plan.
    reaction(
      () =>
        this.selectedTradePlanId !== null &&
        !this.root.tradePlanStore.tradePlans[this.selectedTradePlanId],
      (selectedPlanIsGone) => {
        if (selectedPlanIsGone) this.clearSelection();
      }
    );
  }

  selectTradePlan = (tradePlanId) => {
    if (tradePlanId === null || tradePlanId === undefined) return;
    const id = `${tradePlanId}`;
    if (!this.root.tradePlanStore.tradePlans[id]) return;
    this.selectedTradePlanId = id;
  };

  clearSelection = () => {
    this.selectedTradePlanId = null;
  };

  isSelected = (tradePlanId) => {
    return (
      this.selectedTradePlanId !== null &&
      this.selectedTradePlanId === `${tradePlanId}`
    );
  };

  get selectedTradePlan() {
    if (this.selectedTradePlanId === null) return null;
    return this.root.tradePlanStore.tradePlans[this.selectedTradePlanId] ?? null;
  }

  // Move selection within an ordered list of trade plan ids (current UI sort
  // order). Only cycles when a selection already exists.
  selectAdjacent = (orderedIds, step) => {
    if (!orderedIds?.length || this.selectedTradePlanId === null) return;
    const currentIndex = orderedIds.indexOf(this.selectedTradePlanId);
    if (currentIndex === -1) {
      this.selectTradePlan(orderedIds[0]);
      return;
    }
    const nextIndex =
      (currentIndex + step + orderedIds.length) % orderedIds.length;
    this.selectTradePlan(orderedIds[nextIndex]);
  };

  selectByOrdinal = (orderedIds, ordinal) => {
    if (!orderedIds?.length) return;
    if (ordinal < 1 || ordinal > orderedIds.length) return;
    this.selectTradePlan(orderedIds[ordinal - 1]);
  };
}
